
(() => {
if(customElements.get('me-fleece-bundle')) return;
class FleeceBundle extends HTMLElement {
 connectedCallback(){
  if(this.ready) return; this.ready=true;
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
  this.owner=this.closest('product-info');
  this.handleSubmit=this.submit.bind(this);
  this.owner?.addEventListener('submit',this.handleSubmit,true);
  this.onChange=()=>this.update(); this.addEventListener('change',this.onChange);
  this.update();
 }
 disconnectedCallback(){this.owner?.removeEventListener('submit',this.handleSubmit,true);this.removeEventListener('change',this.onChange);this.ready=false;}
 selection(){
  const count=Number(this.querySelector('[name="me-pack"]:checked')?.value||1);
  return [...this.querySelectorAll('[data-pair]')].slice(0,count).map(row=>{
    const color=row.querySelector('[data-color]:checked')?.value;
    const size=row.querySelector('[data-size]').value;
    return this.variants.find(v=>v.option1===color&&v.option2===size);
  });
 }
 update(){
  const count=Number(this.querySelector('[name="me-pack"]:checked')?.value||1);
  this.querySelectorAll('[data-pair]').forEach((row,i)=>{row.hidden=i>=count;});
  this.querySelectorAll('[data-pack-card]').forEach(card=>card.classList.toggle('is-selected',Number(card.dataset.packCard)===count));
  const rows=this.querySelector('[data-pair-rows]');
  this.querySelector('[data-pack-card="'+count+'"]').append(rows);
  this.querySelectorAll('[data-pair]').forEach(row=>{row.querySelector('[data-color-label]').textContent=row.querySelector('[data-color]:checked')?.value||'';});
  const selected=this.selection(), available=selected.every(v=>v&&v.available);
  const button=this.owner?.querySelector('[name="add"]');
  if(button){button.disabled=!available;const label=button.querySelector('span');if(label)label.textContent=available?'AGREGAR A LA BOLSA':'AGOTADO';}
  this.querySelector('[data-pack-status]').textContent=available?'':'Esta combinación está agotada.';
 }
 async submit(event){
  if(!event.target.matches('form[action*="/cart/add"]'))return;
  event.preventDefault();event.stopImmediatePropagation();
  if(this.busy)return;
  const selected=this.selection();
  const message=this.querySelector('[data-pack-status]');
  if(selected.some(v=>!v||!v.available)){message.textContent='Esta combinación está agotada.';return;}
  const counts=new Map();selected.forEach(v=>counts.set(v.id,(counts.get(v.id)||0)+1));
  const items=[...counts].map(([id,quantity])=>({id,quantity}));
  this.busy=true;const button=this.owner.querySelector('[name="add"]');button.disabled=true;message.textContent='Agregando tu paquete…';
  try{
    const root=window.Shopify?.routes?.root||'/';
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});
    const data=await response.json();if(!response.ok)throw new Error(data.description||'No se ha podido agregar el paquete.');
    const drawer=document.querySelector('cart-drawer'); if(drawer && typeof drawer.renderContents==='function' && data.sections){drawer.classList.remove('is-empty');drawer.renderContents(data);message.textContent='Tu paquete se agregó a la bolsa.';button.disabled=false;}else{window.location.assign(root+'cart');}
  }catch(error){message.textContent=error.message;button.disabled=false;}finally{this.busy=false;}
 }
}
customElements.define('me-fleece-bundle',FleeceBundle);
document.addEventListener('click',event=>{
 const opener=event.target.closest('[data-fleece-open]');
 if(opener){document.getElementById(opener.dataset.fleeceOpen)?.showModal();}
 const closer=event.target.closest('[data-fleece-close]');
 if(closer){closer.closest('dialog')?.close();}
 const control=event.target.closest('[data-fleece-scroll]');
 if(control){
 const track=control.closest('.me-media').querySelector('.me-track');
 track.scrollBy({left:Number(control.dataset.fleeceScroll)*track.clientWidth*.7,behavior:'smooth'});
 }
});
document.addEventListener('play',event=>{
 if(event.target.matches('.me-video'))document.querySelectorAll('.me-video').forEach(video=>{if(video!==event.target)video.pause();});
},true);
})();

document.querySelectorAll('media-gallery').forEach(gallery=>{const viewer=gallery.querySelector('[id^="GalleryViewer"]');if(!viewer||gallery.querySelector('.me-gallery-controls'))return;viewer.style.position='relative';const nav=document.createElement('div');nav.className='me-gallery-controls';[-1,1].forEach(direction=>{const button=document.createElement('button');button.type='button';button.textContent=direction<0?'‹':'›';button.setAttribute('aria-label',direction<0?'Imagen anterior':'Imagen siguiente');button.addEventListener('click',()=>{const thumbs=[...gallery.querySelectorAll('.thumbnail-list button')];const current=thumbs.findIndex(t=>t.getAttribute('aria-current')==='true');thumbs[(current+direction+thumbs.length)%thumbs.length]?.click();});nav.append(button)});viewer.append(nav)});
